import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Apologetics from "./pages/Apologetics";
import FreeGrace from "./pages/FreeGrace";
import Debates from "./pages/Debates";
import Articles from "./pages/Articles";
import Media from "./pages/Media";
import Resources from "./pages/Resources";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/apologetics" element={<Apologetics />} />
            <Route path="/free-grace" element={<FreeGrace />} />
            <Route path="/debates" element={<Debates />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/media" element={<Media />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
